export * from "./FrameInterval";
export { FrameInterval as default } from "./FrameInterval";
